export enum SessionAuthorityTypes {
  ANONYMOUS = 'ANONYMOUS',
  FULL_AUTHENTICATED_USER = 'FULL_AUTHENTICATED_USER',
  MINIMAL_AUTHENTICATED_USER = 'MINIMAL_AUTHENTICATED_USER',
  USERNAME_PASSWORD = 'USERNAME_PASSWORD',
  GUEST_WEB_RETURNS = 'GUEST_WEB_RETURNS',
}

export type UserSession = {
  shopId: number;
  market: string;
  firstName: string;
  lastName: string;
  deprecatedUser: boolean;
  uuid: string;
  amcUuid: string;
  username: string;
  authorities: Array<{
    authority: SessionAuthorityTypes;
  }>;
  enabled: boolean;
};
